export default __webpack_public_path__ + "static/media/2003.389fb97f.png";